import Vue from 'vue';
import Router from 'vue-router'
import routers from '@/router/routers';
import {
    localToken
} from "@/libs/func";
Vue.use(Router)
    // const router = new Router({
    //     routes
    //     // mode: 'history'
    // })
const LOGIN_ERROR = 'Error'
    // const LOGIN_PAGE_NAME = 'login'
    //前置操作 检测用户是否登录等 未登录通过oauth页面进行登录
routers.beforeEach((to, from, next) => {
    if (to.query.accessToken && typeof(to.query.accessToken) != 'undefined' && to.query.accessToken != 'undefined') {
        let accessToken = to.query.accessToken || ""; //token值
        let expireTime = to.query.expireTime || 7200;
        let tenantID = to.query.tenantID || "";
        let fullPath = to.fullPath
        let tenantName = decodeURIComponent(to.query.tenantName || "阿中助理");
        localToken.set("Bearer " + accessToken, expireTime); //存储token（已经登录的token）
        localToken.setTenant(tenantID, expireTime); //存储商户id
        localToken.setTenantName(tenantName, expireTime); //存储商户id
        localToken.setURL(fullPath, expireTime); //存储商户id
    }
    // 获取商户名称展示在浏览器 start
    let tenantName2 = localToken.getTenantName()
    let title = '阿中助理'
    if (tenantName2) {
        title = tenantName2
    }
    document.title = title + (to.meta.title ? ('-' + to.meta.title) : '')
        // 获取商户名称展示在浏览器 end
        // console.log(routers)
        // const token = localToken.get()
        // if (!token && to.name !== LOGIN_PAGE_NAME) {
        //     // 未登录且要跳转的页面不是登录页
        //     next({
        //         name: LOGIN_ERROR // 跳转到登录页
        //     })
        // } else if (!token && to.name === LOGIN_PAGE_NAME) {
        //     // 未登录且要跳转的页面不是登录页
        //     next()
        // } else if (token && to.name === LOGIN_PAGE_NAME) {
        //     // 已登录且要跳转的页面是登录页
        //     next({
        //         name: 'shopSales' // 跳转到home页
        //     })
    const token = localToken.get()
    if ((!token || typeof(token) == 'undefined') && to.name !== LOGIN_ERROR) {
        // 未登录且要跳转的页面不是登录页
        next({
            name: LOGIN_ERROR // 跳转到登录页
        });
    } else {
        next() // 有权限，可访问
    }
});

export default routers;


// WEBPACK FOOTER //
// ./src/router/index.js